import AuthHelper from "components/auth/helpers";
import { AppURL } from "utils/Actions";
import moment from "moment";

export const handleRedirect = (history: any, location?: any): void | string => {
  const existingSessionExpireTime = localStorage.getItem(AuthHelper.SESSION_EXPIRE_TIME);
  const justBefore = moment().subtract(1, "seconds");
  const sessionValid = justBefore.isBefore(moment(existingSessionExpireTime));
  if (AuthHelper.isAuthed() && sessionValid) {
    if (AuthHelper.isSchoolUser()) {
      history.push(AppURL.school.path);
    } else if (AuthHelper.isUnencrypted()) {
      history.push(AppURL.setPassword);
    } else {
      return "Your account has no roles.";
    }
  } else {
    AuthHelper.clearAuth();
    location ? history.push(location) : history.push(AppURL.login);
  }
};
